import React, { useEffect } from 'react'
import Navbar from '../global-components/navbar'
import PageHeader from '../global-components/page-header'
import Footer from '../global-components/footer'
import ImageGallery from 'react-image-gallery'
import { Container, Button } from 'react-bootstrap'

import Image1 from '../../assets/img/MapImages/1.jpg'
import Image2 from '../../assets/img/MapImages/2.jpg'
import Image3 from '../../assets/img/MapImages/3.jpg'
import Image4 from '../../assets/img/MapImages/4.jpg'
import Image5 from '../../assets/img/MapImages/5.jpg'
import Image6 from '../../assets/img/MapImages/6.jpg'
import Image7 from '../../assets/img/MapImages/7.jpg'
import Image8 from '../../assets/img/MapImages/8.jpg'
import Image9 from '../../assets/img/MapImages/9.jpg'
import Image10 from '../../assets/img/MapImages/10.jpg'
import './mapstyle.scss'
import useFetch from '../../Hooks/useFetch'
import PostList from '../blog-components/post-list'

const Maps = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  // console.log(props.location)
  // console.log(props.match)
  // console.log(props.history)

  const { data } = useFetch()

  const myField = data?.items.find((item, index) => {
    if (item.sys.id === '26O6orOLo6JoLGnaPpuuzi') {
      return item
    }
  })

  // console.log(myField?.fields)
  // console.log(baseUrl + data?.Images[0].image.url)
  return (
    <div>
      <Navbar />
      <PageHeader
        headertitle='Maps'
        Imagefile={myField?.fields.phTitle.fields.file.url}
      />
      {/* <div className="py-5" style={{ minHeight: "70vh" }}>
        <Container>
          <ImageGallery lazyLoad={true} items={images} />
        </Container>
      </div> */}
      <Container className='mt-5'>
        <Button
          target='_blank'
          href={myField?.fields.btnlink}
          variant='secondary'
        >
          {' '}
          Download Maps{' '}
        </Button>
      </Container>
      <PostList posts={myField?.fields.images} map />
      <Footer />
    </div>
  )
}

const images = [
  {
    image: Image1,
    title: 'AZCA Real Estate Bahria Enclave',
  },
  {
    image: Image2,
    title: 'AZCA Real Estate Bahria Garden City Zon',
  },
  {
    image: Image3,
    title: 'AZCA Real Estate Bahria Orchard',
  },
  {
    image: Image4,
    title: 'AZCA Real Estate Bahria Pindi Phase I - VI ',
  },
  {
    image: Image5,
    title: 'AZCA Real Estate Bahria Pindi Phase VII ',
  },
  {
    image: Image6,
    title: 'AZCA Real Estate Bahria Pindi Phase VIII ',
  },
  {
    image: Image7,
    title: 'AZCA Real Estate DHA Phase I Islamabad',
  },
  {
    image: Image8,
    title: 'AZCA Real Estate DHA Phase II Islamabad',
  },
  {
    image: Image9,
    title: 'AZCA Real Estate DHA Phase IV Islamabad',
  },
  {
    image: Image10,
    title: 'AZCA Real Estate DHA Phase V Islamabad',
  },
]

export default Maps
